import { metrics } from "@opentelemetry/api";
import {
  MeterProvider,
  PeriodicExportingMetricReader,
} from "@opentelemetry/sdk-metrics";
import { OTLPMetricExporter } from "@opentelemetry/exporter-metrics-otlp-http";
import { resourceFromAttributes } from "@opentelemetry/resources";

/**
 * @typedef {Object} SignozConfig
 * @property {string} url - SigNoz endpoint URL
 * @property {string} ingestionKey - SigNoz ingestion key
 * @property {string} [environment] - Environment name (default: "production")
 */

/**
 * Initialize OpenTelemetry Metrics with SigNoz configuration
 * @param {SignozConfig} config - Configuration object
 * @returns {MeterProvider} The configured meter provider
 */
export function initializeOpenTelemetry(config) {
  const { url, ingestionKey, environment = "production" } = config;

  // Create a resource with service information
  const resource = resourceFromAttributes({
    "service.name": "dx-frontend",
    "service.namespace": "frontend",
    environment: environment,
  });

  // Create the OTLP metric exporter
  const exporter = new OTLPMetricExporter({
    url: url,
    headers: {
      "signoz-ingestion-key": ingestionKey,
    },
  });

  // Create a metric reader with periodic export (every 10 seconds)
  const metricReader = new PeriodicExportingMetricReader({
    exporter: exporter,
    exportIntervalMillis: 10000, // Export every 10 seconds
  });

  // Create and configure the meter provider
  const meterProvider = new MeterProvider({
    resource: resource,
    readers: [metricReader],
  });

  // Set the global meter provider
  metrics.setGlobalMeterProvider(meterProvider);

  return meterProvider;
}
